export function apenasNumeros(valor) {
  return (valor || "").replace(/\D/g, "");
}

export function mascaraTelefone(valor) {
  let numero = apenasNumeros(valor);
  if ((numero.length === 12 || numero.length === 13) && numero.startsWith("55")) numero = numero.slice(2);
  const v = numero.slice(0, 11);
  if (v.length <= 10) {
    return v.replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d{4})(\d)/, "$1-$2");
  }
  return v.replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d)/, "$1-$2");
}

export function mascaraCpfCnpj(valor) {
  const v = apenasNumeros(valor).slice(0, 14);
  if (v.length <= 11) {
    return v.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return v.replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
}

export function formatarMoeda(valor) {
  return Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function moedaParaNumero(valor) {
  if (typeof valor === "number") return valor;
  const somenteNumeros = apenasNumeros(String(valor || ""));
  return Number(somenteNumeros || 0) / 100;
}

export function mascaraMoeda(valor) {
  return formatarMoeda(moedaParaNumero(valor));
}

export function formatarDataHora(valor) {
  if (!valor) return "";
  return new Date(valor).toLocaleString("pt-BR");
}
